import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51008b39"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label-content" }

import { computed, ref, watch } from "vue";
import { ChevronDownCompact } from "tir-style-system/icons/solid";


export default /*#__PURE__*/_defineComponent({
  __name: 'label-content',
  props: {
  /**Видно ли тело списка */
  visible: {
    type: Boolean,
    default: false,
  },
  /**Режим открытия по флагу из пропса */
  flagMode: {
    type: Boolean,
    default: false,
  },
  /**Задержка */
  delay: {
    type: Number,
    default: 500,
  },
  /**Отключить анимацию */
  disableAnimation: {
    type: Boolean,
    default: false
  }
},
  emits: ["open", "update:visible"],
  setup(__props, { emit }) {

const props = __props;



/**События */


/**Видно ли тело списка */
const innerVisible = ref(props.visible);
/**Элемент тела компонента */
const $body = ref<HTMLDivElement>();
/**Позиционирование и размеры блока */
const bodyRect = ref<DOMRect>();

/**Стили тела компонента */
const bodyStyle = computed(() => ({
  height: bodyRect.value ? `${bodyRect.value.height}px` : "",
}));

watch(
  () => props.visible,
  () => {
    if (props.flagMode && innerVisible.value !== props.visible) {
      toggleVisibility(true);
    }
  },
);

/**Переключение видимости тела компонента */
const toggleVisibility = (fromWatch: boolean = false) => {
  if (props.flagMode) {
    if (fromWatch) {
      innerVisible.value = !innerVisible.value;
    } else {
      emit("update:visible", !innerVisible.value);
    }

    return;
  }

  if (innerVisible.value) {
    bodyRect.value = $body.value?.getBoundingClientRect?.();
    setTimeout(() => {
      innerVisible.value = !innerVisible.value;
    });
  } else {
    bodyRect.value = undefined;
    setTimeout(() => {
      innerVisible.value = !innerVisible.value;
    }, props.delay);
    if (!fromWatch) emit("open");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "label-content_header",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleVisibility(false)))
    }, [
      _renderSlot(_ctx.$slots, "header"),
      _createVNode(_unref(ChevronDownCompact), {
        class: _normalizeClass(["label-content_header_arrow", { visible: innerVisible.value }])
      }, null, 8, ["class"])
    ]),
    _createVNode(_Transition, { name: "label-content_fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          ref_key: "$body",
          ref: $body,
          class: _normalizeClass(['label-content_body', {'disable-animation': __props.disableAnimation}]),
          style: _normalizeStyle(bodyStyle.value)
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 6), [
          [_vShow, innerVisible.value]
        ])
      ]),
      _: 3
    })
  ]))
}
}

})